import { fetcher } from 'src/config/request';
import { PageActionEndpoints } from './endpoints';
export const PageActionsService = {
    duplicatePage(payload) {
        return fetcher.post(PageActionEndpoints.duplicatePage(), {
            page: payload.sourcePageId,
            newName: payload.newPageName,
            contextId: payload.contextId
        });
    },
    renamePage(pageId, name) {
        return fetcher.put(PageActionEndpoints.renamePage(pageId), { name });
    },
    reorderPage({ pageId, targetPageOrderId, newModuleId }) {
        return fetcher.post(PageActionEndpoints.reorderPage(pageId), { targetPageOrderId, newModuleId });
    }
};
